export function LangleyHero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section className="relative min-h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/0612dc43aac7df46ef19a427d72990cc.jpg"
          alt="Langley community"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-5xl mx-auto px-6 lg:px-12 text-center text-white py-24">
        <h1 className="font-['Fraunces'] text-5xl lg:text-6xl font-bold mb-6 leading-tight">
          Langley Short-Term Rental<br />Licensing Framework
        </h1>
        <p className="text-xl lg:text-2xl mb-8 text-white/90 max-w-3xl mx-auto leading-relaxed">
          Navigate Langley's flexible bylaw framework with expert guidance for Township and City regulations
        </p>
        <button 
          onClick={scrollToContact}
          className="bg-[#882629] text-white px-10 py-5 rounded-full text-lg font-medium hover:bg-[#6E1F22] transition-all cursor-pointer whitespace-nowrap shadow-xl hover:shadow-2xl"
        >
          Get Langley Licensing Help
        </button>
      </div>
    </section>
  );
}
